<!--
 * @description: 特色介绍
 * @Author: wxy
 * @Date: 2020-02-11 14:05:58
 -->
<template>
  <div class="container">
    <block-title>特色介绍</block-title>
    <el-row :gutter="70">
      <el-col :span="8" v-for="(item,index) in list" :key="index">
        <img :src="item.url" />
        <p class="title">{{item.title}}</p>
        <p class="text">{{item.text}}</p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import blockTitle from './blockTitle'
export default {
  name: '',
  components: { blockTitle },
  data () {
    return {
      list: [
        {
          url: require('@/assets/img/dashboard/feature1.png'),
          title: '以沟通为基础',
          text: '全面打通审批流和IM，让业务都是建立在沟通基础之上，流程中发起讨论，还有场景化的聊天等。'
        },
        {
          url: require('@/assets/img/dashboard/feature2.png'),
          title: '系统开发工具化',
          text: '流程模块化，降低系统的定制成本，几乎全部业务都是通过配置来完成，降低因业务定制代码而带来的成本。'
        },
        {
          url: require('@/assets/img/dashboard/feature3.png'),
          title: '多终端移动办公',
          text: '网页、APP、桌面客户端，随时随地移动办公，形成以业务为主导的办公习惯。减少事等人所带来的业务风险。'
        },
        {
          url: require('@/assets/img/dashboard/feature4.png'),
          title: '数据中台组件',
          text: '将不同源的各业务系统数据实现数据汇聚，打破数据孤岛，并对外提供数据服务。'
        },
        {
          url: require('@/assets/img/dashboard/feature5.png'),
          title: '微服务框架',
          text: '人事、财务、资产、行政等都是微服务的形式存在，这就让整个系统具备了一定的抗风险能力。'
        },
        {
          url: require('@/assets/img/dashboard/feature6.png'),
          title: '云环境',
          text: '依托紫光云的云环境，对外提供云化的OA服务，为企业提供更低成本、更稳定的服务，云环境上也会有越来越多的合作伙伴加入，这些服务都OA的用户也是开放的。'
        }
      ]
    }
  }
}
</script>

<style lang='scss' scoped>
.container {
  background: #fff;
  border-radius: 6px;
  padding: 0px 90px 0px 90px;
  box-shadow:0px 5px 30px 0px rgba(51,53,155,0.16);
  .el-col{
    text-align: center;
    margin-bottom: 50px;
    img{
      width: 100%;
      height: auto;
    }
    .title{
      font-size: 15px;
      line-height: 50px;
      letter-spacing: 1px;
      color: #333;
    }
    .text{
      text-align: left;
      font-size: 12px;
      line-height: 20px;
      letter-spacing: 1px;
      color: #666;
    }
  }
}
@media (max-width: 770px) {
  .container {
    padding: 0 16px;
    .el-col {
      width: 100%;
    }
  }
}
</style>
